import trackSplitEventQuery from '../GraphQL/Customer/trackSplitEvent'

const query = trackSplitEventQuery
//this is the only header that works with sendbeacon
const headers = {
  type: 'application/json',
}

const useSplitTrackEvent = async (eventName) => {
  try {
    if (!eventName) {
      throw 'eventName must be specified'
    }
    const variables = {
      eventName: eventName,
    }
    const body = {
      query,
      variables,
    }

    const blob = new Blob([JSON.stringify(body)], headers)
    const isQueued = await navigator.sendBeacon('/graphql/customer', blob)

    if (!isQueued) {
      throw 'Split Event Tracking was not queued for sendbeacon'
    }
    return isQueued
  } catch (error) {
    console.error(`error sending split track event: ${eventName}`, error)
  }
  return false
}

export default useSplitTrackEvent
